// src/features/captions/eligibility.ts

/**
 * Pure resolution of live automated captions visibility (unit-tested per
 * ADR-004); useCaptionsEligibility is its only runtime caller. All three
 * inputs must allow: the build flag, media access, and the per-account
 * entitlement. The flag + entitlement pair IS the launch mechanism — there is
 * no separate rollout switch. Unlike Legacy Reports' server verdict (which is
 * fail-open), the entitlement fails CLOSED: an absent
 * `allowAutomatedCaptions` (customer info not loaded, or a gateway predating
 * the field) resolves NOT eligible — captions must never be teased to
 * unentitled accounts. Visibility only; the server independently rejects
 * unentitled calls on every /v1/captions route (403).
 */
export function resolveCaptionsEligibility(inputs: {
  flagEnabled: boolean;
  mediaAccess: boolean;
  allowAutomatedCaptions: boolean | undefined;
}): boolean {
  return inputs.flagEnabled && inputs.mediaAccess && (inputs.allowAutomatedCaptions ?? false);
}
